import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Header } from '../../header';
import { useNotify } from "tailwind-notifications-react";
import classNames from 'classnames';

export const CouponsPage = () => {
  const [coupons, setCoupons] = useState([]);
  const [products, setProducts] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [step, setStep] = useState(0);
  const [couponType, setCouponType] = useState(null);
  const [couponName, setCouponName] = useState('');
  const [discountPercent, setDiscountPercent] = useState(10);
  const [noExpiration, setNoExpiration] = useState(false);
  const [expirationDate, setExpirationDate] = useState('');
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [editingCouponId, setEditingCouponId] = useState(null);
  const notify = useNotify();
  const token = localStorage.getItem('token');

  useEffect(() => {
    fetchCoupons();
    fetchProducts();
  }, []);
  

  const fetchCoupons = async () => {
    try {
      const response = await axios.get('https://api.alyonatestsite.store/api/coupons', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setCoupons(response.data);
    } catch (error) {
      console.error('Ошибка загрузки купонов:', error);
    }
  };

  const fetchProducts = async () => {
    try {
      const response = await axios.get('https://api.alyonatestsite.store/api/products', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setProducts(response.data);
    } catch (error) {
      console.error('Ошибка загрузки товаров:', error);
    }
  };

  const handleProductSelect = (id) => {
    setSelectedProducts(prev =>
      prev.includes(id) ? prev.filter(pid => pid !== id) : [...prev, id]
    );
  };

  const handleCreateCoupon = async () => {
    const payload = {
      name: couponName,
      discount: discountPercent,
      noExpiration,
      expirationDate: noExpiration ? null : expirationDate,
      type: couponType,
      products: couponType === 'products' ? selectedProducts : [],
    };

    try {
      if (editingCouponId) {
        await axios.put(`https://api.alyonatestsite.store/api/coupons/${editingCouponId}`, payload, {
          headers: { Authorization: `Bearer ${token}` }
        });
        notify({ title: "Обновлено", message: "Купон обновлён", type: "success" });
      } else {
        await axios.post('https://api.alyonatestsite.store/api/coupons', payload, {
          headers: { Authorization: `Bearer ${token}` }
        });
        notify({ title: "Создано", message: "Купон создан", type: "success" });
      }

      setModalOpen(false);
      resetForm();
      fetchCoupons();
    } catch (err) {
      console.error('Ошибка при сохранении купона:', err);
    }
  };

  const handleEditCoupon = (coupon) => {
    setCouponName(coupon.name);
    setDiscountPercent(coupon.discount);
    setNoExpiration(coupon.noExpiration);
    setExpirationDate(coupon.expirationDate ? new Date(coupon.expirationDate).toISOString().split("T")[0] : '');
    setCouponType(coupon.appliesToAll ? 'all' : 'products');
    setSelectedProducts(coupon.products || []);
    setEditingCouponId(coupon._id);
    setStep(coupon.appliesToAll ? 1 : 2);
    fetchProducts();
    setModalOpen(true);
  };

  const handleDeleteCoupon = async (id) => {
    if (!window.confirm("Удалить этот купон?")) return;
    try {
      await axios.delete(`https://api.alyonatestsite.store/api/coupons/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      notify({ title: "Удалено", message: "Купон удалён", type: "success" });
      fetchCoupons();
    } catch (err) {
      console.error('Ошибка удаления купона:', err);
      notify({ title: "Ошибка", message: "Не удалось удалить купон", type: "error" });
    }
  };

  const resetForm = () => {
    setStep(0);
    setCouponType(null);
    setCouponName('');
    setDiscountPercent(10);
    setNoExpiration(false);
    setExpirationDate('');
    setSelectedProducts([]);
    setEditingCouponId(null);
  };

  const openModal = () => {
    resetForm();
    setModalOpen(true);
  };

  return (
    <section className="bg-white min-h-screen">
      <Header fixed={false} />
      <div className="p-8 max-w-5xl mx-auto">
        <h1 className="text-3xl font-bold mb-6">Купоны на скидку</h1>

        <button
          onClick={openModal}
          className="bg-green-600 text-white px-6 py-3 rounded mb-6"
        >
          Создать купон
        </button>

        <div className="grid gap-4">
          {coupons.map(coupon => (
            <div key={coupon._id} className="border p-4 rounded shadow">
              <h3 className="font-bold text-lg">{coupon.name}</h3>
              <p>Скидка: {coupon.discount}%</p>
              <p>Тип: {coupon.appliesToAll ? "На весь заказ" : "На отдельные товары"}</p>

              {!coupon.appliesToAll && coupon.products.length > 0 && (
                <div className="flex flex-wrap gap-2 mt-2">
                  {coupon.products.map((productId, index) => {
                    const product = products.find(p => p.id === productId);
                    return product ? (
                      <div key={index} className="flex items-center gap-1 text-sm">
                        <img src={`https://api.alyonatestsite.store${product.images[0]}`} alt={product.name} className="w-8 h-8 object-cover rounded" />
                        <span>{product.name}</span>
                      </div>
                    ) : null;
                  })}
                </div>
              )}

              <div className="flex gap-2 mt-4">
                <button
                  onClick={() => handleEditCoupon(coupon)}
                  className="bg-yellow-500 text-white px-3 py-1 rounded"
                >
                  Редактировать
                </button>
                <button
                  onClick={() => handleDeleteCoupon(coupon._id)}
                  className="bg-red-600 text-white px-3 py-1 rounded"
                >
                  Удалить
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {modalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white w-full max-w-5xl p-6 rounded shadow relative max-h-[90vh] overflow-y-auto">
            <button
              onClick={() => setModalOpen(false)}
              className="absolute top-3 right-3 text-gray-500 hover:text-black"
            >
              ✕
            </button>

            {step === 0 && (
              <>
                <h2 className="text-2xl font-bold mb-4">Тип купона</h2>
                <div className="flex flex-col gap-4">
                  <button
                    onClick={() => {
                      setCouponType('all');
                      setStep(1);
                    }}
                    className="bg-blue-500 text-white px-4 py-2 rounded"
                  >
                    На весь заказ
                  </button>
                  <button
                    onClick={() => {
                      setCouponType('products');
                      setStep(2);
                      fetchProducts();
                    }}
                    className="bg-sky-500 text-white px-4 py-2 rounded"
                  >
                    На определённые товары
                  </button>
                </div>
              </>
            )}

            {step === 1 && (
              <>
                <h2 className="text-2xl font-bold mb-4">Детали купона</h2>
                <input
                  type="text"
                  placeholder="Название купона"
                  className="border p-2 rounded w-full mb-4"
                  value={couponName}
                  onChange={(e) => setCouponName(e.target.value)}
                />
                <div className="flex items-center gap-2 mb-4">
                  <input
                    type="number"
                    min={1}
                    max={100}
                    value={discountPercent}
                    onChange={(e) => setDiscountPercent(e.target.value)}
                    className="border p-2 rounded w-24"
                  />
                  <span>% скидки</span>
                </div>
                <div className="flex justify-end gap-4">
                  <button
                    onClick={() => setModalOpen(false)}
                    className="bg-gray-400 text-white px-4 py-2 rounded"
                  >
                    Отмена
                  </button>
                  <button
                    onClick={handleCreateCoupon}
                    className="bg-green-600 text-white px-4 py-2 rounded"
                  >
                    Создать купон
                  </button>
                </div>
              </>
            )}

            {step === 2 && (
              <>
                <h2 className="text-2xl font-bold mb-4">Выберите товары</h2>
                <div className="grid grid-cols-3 gap-4 max-h-[50vh] overflow-y-auto">
                  {products.map(product => (
                    <div
                      key={product.id}
                      onClick={() => handleProductSelect(product.id)}
                      className={classNames(
                        "border p-2 rounded cursor-pointer relative",
                        selectedProducts.includes(product.id)
                          ? "border-blue-600 bg-blue-50"
                          : "hover:bg-gray-100"
                      )}
                    >
                      <img src={`https://api.alyonatestsite.store${product.images[0]}`} alt={product.name} className="w-full h-48 object-cover mb-1 rounded" />
                      <div className="mt-4 font-semibold text-base font-lack">{product.name}</div>
                      <div className="text-xs text-gray-600">Артикул: {product.sku}</div>
                      <div className={`${product.discount === 0 && 'hidden'} inline-flex mt-2 items-center space-x-4`}>
              <p className={`bg-sky-600 px-2 file:text-xl lg:text-1xl font-lack text-white`}>
                {product.discount} руб.
              </p>
              <p className={`font-lack text-lg lg:text-xl line-through`}>{product.price} руб.</p>
            </div>
            <p className={`${product.discount === 0 ? 'flex' : 'hidden'} text-xl lg:text-1xl font-lack text-black mt-2`}>
              {product.price} руб.
            </p>
                      {selectedProducts.includes(product.id) && (
                        <div className="absolute top-1 right-1 bg-green-500 text-white text-xs px-1 rounded">
                          ✓
                        </div>
                      )}
                    </div>
                  ))}
                </div>
                {selectedProducts.length > 0 && (
                  <div className="mt-6">
                    <button
                      onClick={() => setStep(1)}
                      className="bg-blue-600 text-white px-4 py-2 rounded"
                    >
                      Далее
                    </button>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      )}
    </section>
  );
};
